import { render, staticRenderFns } from "./Collapsible.vue?vue&type=template&id=0e3a7d60&scoped=true"
import script from "./Collapsible.vue?vue&type=script&lang=js"
export * from "./Collapsible.vue?vue&type=script&lang=js"
import style0 from "./Collapsible.vue?vue&type=style&index=0&id=0e3a7d60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3a7d60",
  null
  
)

export default component.exports